import { FunctionComponent } from 'react';
import FirstPanelStatusDrivers from './FirstPanelStatusDrivers';
import { ChoferTrabajando } from 'app/chofer/models/ChoferTrabajando';
import { DriversMonitor } from '../NewDriversMonitor';
import { MonitorDriversInfo } from '../../types/Driver';

interface ContainerMonitorProps {
  setDriverDetail: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      details: ChoferTrabajando | undefined;
    }>
  >;
  monitorDriversInfo: MonitorDriversInfo;
  statusActive: string;
  onFilterByStatusDriver: (state: string) => void;
  isLoadingDrivers: boolean;
  drivers: ChoferTrabajando[];
}

const ContainerMonitor: FunctionComponent<ContainerMonitorProps> = ({
  setDriverDetail,
  drivers,
  monitorDriversInfo,
  statusActive,
  onFilterByStatusDriver,
  isLoadingDrivers,
}) => {
  return (
    <>
      <FirstPanelStatusDrivers
        statusActive={statusActive}
        onFilterByStatusDriver={onFilterByStatusDriver}
        amountPerState={
          monitorDriversInfo ?? {
            busy: 0,
            free: 0,
            onBrake: 0,
            workdayNotStarted: 0,
            workdayStarted: 0
          }
        }
        isLoadingDrivers={isLoadingDrivers}
      />

      {isLoadingDrivers && (
        <div
          role="status"
          className="py-2 text-xs text-gray-500 dark:text-inkMuted-dark"
        >
          {drivers.length > 0 ? 'Actualizando choferes...' : 'Cargando choferes...'}
        </div>
      )}
      {!isLoadingDrivers && drivers.length === 0 && (
        <div className="py-2 text-xs text-gray-500 dark:text-inkMuted-dark">
          No hay choferes para el filtro seleccionado.
        </div>
      )}
      {drivers.length > 0 && (
        <DriversMonitor
          statusActive={statusActive}
          isActive={statusActive.length !== 0}
          showDriversSleeping={statusActive === 'ON_BRAKE'}
          workingDrivers={drivers}
          driversWorkingDayNotStarted={[]}
          groupType="current_district"
          showDriverDetails={(driver) =>
            setDriverDetail({ isOpen: true, details: driver })
          }
        />
      )}
    </>
  );
};

export default ContainerMonitor;
